import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3d6e2c4e&shadow"
import script from "./Footer.vue?vue&type=script&lang=ts&shadow"
export * from "./Footer.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./Footer.vue?vue&type=style&index=0&id=3d6e2c4e&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports